module.exports = __webpack_public_path__ + "static/media/retail3.36e89fd3.jpeg";